// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './Rating.scss';
import icons from '../../assets/styles/icons.scss';

type Props = {
  +rating: number;
  +totalRating: number;
  +className?: { [key: string]: string };
};

const Rating = (props: Props) => {
  const { rating, totalRating, className } = props;
  return (
    <div className={classNames(style.starWrap, className)}>
      <div className={style.filled}
           style={{ width: `${((rating / totalRating) * 100).toFixed(2)}%` }}>
        {(new Array(totalRating)).fill(0).map((_, index: number) =>
          <i key={`filled-${index}`}
             className={icons.iconStarMedium}/>)}
      </div>
      {(new Array(totalRating)).fill(0).map((_, index: number) =>
        <i key={`empty-${index}`}
           className={icons.iconStarMedium}/>)}
    </div>
  );
};

Rating.propTypes = {};

export default Rating;



// WEBPACK FOOTER //
// ./src/elements/Rating/Rating.jsx